import { useHistory } from 'react-router';

import { Topbar } from '../../components/Topbar';
import UserPostForm, { INewLessonRequest } from './UserPostForm';
import useLessonRequestCreate from '../../hooks/useLessonRequestCreate';
import useImageUpload from '../../hooks/useImageUpload';

const HIDDEN_ATTRS = new Set<keyof INewLessonRequest>(['closed']);

export const AddUserPost = () => {
  const { push } = useHistory();
  const { createLessonRequest } = useLessonRequestCreate();
  const { handleImageChange, isUploading } = useImageUpload();

  const submit = async (lessonRequest: INewLessonRequest) => {
    try {
      await createLessonRequest(lessonRequest);
    } catch (error) {
      alert('저장 중 에러가 발생했습니다. ' + (error as Error).message);
      return;
    }

    push('/post/user');
  };

  return (
    <>
      <Topbar text="레슨 요청 작성" back={true} />

      <UserPostForm
        onSubmit={submit}
        hiddenAttrs={HIDDEN_ATTRS}
        onImageChange={handleImageChange}
        isImageUploading={isUploading}
      />
    </>
  );
};
